import React from 'react';
import archivo from '../assets/archivo.png';
import robot1 from '../assets/robot1.png';
import { useNavigate } from 'react-router-dom';

export default function VamosAIniciar() {
    const Navigate = useNavigate();
    return (
        <div className='bg-[#0346a4] py-20'>
            <p className='text-5xl font-bold  text-white px-20 pb-10'>¡Vamos a iniciar! </p>
            <div className="relative min-h-screen w-full bg-[#0346a4] flex items-center justify-center text-white">
                
                <img src={robot1} alt="robot" className="absolute right-0 top-4 w-[80%] " />
                <div className="bg-[#e8f2f4] text-black p-6 rounded-lg shadow-lg w-full mx-20 flex flex-col md:flex-row relative z-10">
                    <div className="w-full md:w-1/2 flex flex-col items-center justify-center p-4">
                        <h1 className="text-5xl font-bold text-center text-[#0053c7] max-w-xl">¡Así de rápido puedes abrir tu CDT</h1>
                        <img src={archivo} alt="archivo" className="w-48 mt-4" />
                    </div>
                    <div className="w-full md:w-1/2 p-4">
                        <ul className="space-y-4 text-sm">
                            <li className="border-l-4 border-blue-600 pl-3  text-2xl text-[#022351] font-bold">
                                Cuéntale al banco sobre ti
                                <p className="text-[#414d79] text-lg  mt-1">Colabora a Ban100 para que te conozcan mejor completando tu información personal, financiera y respondiendo a algunas preguntas específicas.</p>
                            </li>
                            <li className="border-l-4 border-blue-600 pl-3 text-2xl text-[#022351] font-bold">
                                Carga tus documentos
                                <p className="text-[#414d79] text-lg mt-1">Ahora es el momento de subir tus documentos. Ten preparado tu documento de identidad y tu declaración de renta. Si no realizas declaración de renta, puedes cargar los extractos bancarios de los últimos tres meses, un comprobante de nómina o una certificación laboral.</p>
                            </li>
                            <li className="border-l-4 border-blue-600 text-2xl pl-3 text-[#022351] font-bold">
                                Firma y asegura tu tasa
                                <p className="text-[#414d79] text-lg mt-1">La forma de firmar puede ser digital o en físico, dependiendo del banco o la entidad financiera. Si es digital, tendrás que tener a mano tu documento de identidad y estar listo para tomarte una selfie.</p>
                            </li>
                            <li className="border-l-4 border-blue-600 pl-3 text-2xl text-[#022351] font-bold">
                                Completa tu pago y ¡ya!
                                <p className="text-[#414d79] text-lg mt-1">Haz el depósito directamente a Ban100 a través de transferencia, consignación de cheque o en efectivo, según las opciones disponibles en ese momento. Luego de realizar el depósito, sube el comprobante de pago para confirmar la apertura de tu CDT y recibir el comprobante en los plazos establecidos por Ban100.</p>
                            </li>
                        </ul>
                        <div className="mt-4 text-lg py-8 flex items-start">
                            <input type="checkbox" className="mt-2" />
                            <p className="ml-2 text-[#414d79]">
                                Confirmo que he leído y acepto los términos y condiciones, además de autorizar el uso de mis datos personales y financieros por parte de Ban100 conforme a su política de privacidad.
                            </p>
                        </div>
                        <button onClick={()=>{Navigate("/personas/cdt/formulario")}} className="mt-4 w-full bg-green-600 text-white py-2 rounded font-semibold">Continuar</button>
                    </div>
                </div>
            </div>
        </div>

    );
}